import { createContext } from 'react'

const IncidentHighRiskContext = createContext()

export default IncidentHighRiskContext
